import View from './view';
export const NotificationWidget = View;
